import { Link } from 'react-router-dom';

interface FooterProps {
  onOpenForm?: () => void;
}

export default function Footer({ onOpenForm }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/e58699e4b53dee9b9c27b84028657016.png" 
              alt="星耀科技" 
              className="h-12 mb-4 object-contain"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              專注於為中小企業提供專業的網站建置與數位行銷服務，
              協助品牌建立線上形象，觸及更多潛在客戶。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">快速連結</h4>
            <ul className="space-y-3">
              <li>
                <a href="#what-is-this" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  什麼是 0 元一頁式網站
                </a>
              </li>
              <li>
                <a href="#partnership" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  年度管理方案
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  聯絡我們
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400 text-sm">
                <i className="ri-mail-line mr-3 text-teal-400"></i>
                server@xingyaotech.tw
              </li>
              <li className="flex flex-col">
                <Link
                  to="/consultation"
                  className="flex items-center text-teal-400 hover:text-teal-300 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-chat-smile-3-line mr-3"></i>
                  免費諮詢申請
                </Link>
                <span className="text-xs text-gray-500 mt-1 ml-8">填寫資料,我們將盡快與您聯繫</span>
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <i className="ri-map-pin-line mr-3 text-teal-400"></i>
                台灣
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 0元一頁式網站. All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-8 bg-gray-800/50 rounded-lg p-6 border border-gray-700">
          <div className="flex items-start">
            <i className="ri-information-line text-teal-400 text-xl mr-3 mt-1 flex-shrink-0"></i>
            <div>
              <h5 className="text-sm font-semibold text-white mb-2">※ 補充說明</h5>
              <p className="text-xs text-gray-400 leading-relaxed">
                0元一頁式網站服務需簡單需求確認後提供，<br />
                本服務適用於有實際商業需求之公司或品牌，<br />
                非所有情況均適用。
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
